import { Modal } from 'components/UI/Modal'

export type ModalView = 'list' | 'email' | 'compose'

interface EmailsModalHeaderProps {
  view?: ModalView
  companyName?: string
  emailSubject?: string
  /** When true, shows a simple header without breadcrumb navigation */
  emailOnlyMode?: boolean
  /** When true, the inbox is scoped to a deal — titles "Deal Inbox" instead
   *  of "Company Inbox". */
  isDealInbox?: boolean
}

/** Modal header with company name subtitle and view-dependent title. */
export function EmailsModalHeader({
  view,
  companyName,
  emailSubject,
  emailOnlyMode,
  isDealInbox,
}: EmailsModalHeaderProps) {
  // Email-only mode: simple header with just the subject
  if (emailOnlyMode) {
    return (
      <Modal.Header className="px-[32px] py-[20px] border-0">
        <div className="flex flex-col gap-1 w-full">
          {companyName && (
            <div className="text-sm font-medium text-neutral-500">
              {companyName}
            </div>
          )}
          <Modal.Title className="text-2xl font-normal leading-[1.2] tracking-[0em] align-middle text-neutral-900 m-0">
            {emailSubject || 'Email'}
          </Modal.Title>
        </div>
      </Modal.Header>
    )
  }

  const title =
    view === 'compose'
      ? 'Compose an email'
      : isDealInbox
        ? 'Deal Inbox'
        : 'Company Inbox'

  return (
    <Modal.Header className="px-[24px] pt-[24px] pb-[16px] border-0">
      <div className="flex flex-col gap-0.5 w-full">
        <div className="text-sm font-medium text-neutral-500">
          {companyName}
        </div>
        <Modal.Title className="text-xl font-semibold leading-[28px] text-neutral-800 m-0">
          {title}
        </Modal.Title>
      </div>
    </Modal.Header>
  )
}
